/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Friends_My_CodeInputs */

const en_friends_my_code = /** @type {(inputs: Friends_My_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your friend code`)
};

const de_friends_my_code = /** @type {(inputs: Friends_My_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Euer Freundescode`)
};

/**
* | output |
* | --- |
* | "Your friend code" |
*
* @param {Friends_My_CodeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const friends_my_code = /** @type {((inputs?: Friends_My_CodeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friends_My_CodeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_friends_my_code(inputs)
	return en_friends_my_code(inputs)
});